<template>
   <div class="visuals">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteVisuals()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-10 col-lg-8 col-xl-6" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">{{VisualsModel.forms.addVisuals.title}}</div>
            <div class="subtitle">{{VisualsModel.forms.addVisuals.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Wizard 
                  :loading="loading"
                  :reset="resetForm"
                  :forms="[
                     VisualsModel.forms.addVisuals,
                     VisualsModel.forms.nextPageVisualization,
                  ]"
                  @submit-form="addVisuals"
                  @next_page="wizardNextVisual"
               />
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-10 col-lg-8 col-xl-6" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{VisualsModel.forms.editVisuals.title}}</div>
            <div class="subtitle">{{VisualsModel.forms.editVisuals.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Wizard 
                  :loading="loading"
                  :reset="resetFormUpdate"
                  :forms="[
                     VisualsModel.forms.editVisuals,
                     VisualsModel.forms.nextPageVisualization,
                  ]"
                  @submit-form="updateVisuals"
                  @next_page="wizardNextVisual"
               />
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Visuals <i class="fa fa-plus"></i>
         </div>
      </div>
      
      <Table v-bind="VisualsModel.tables.visuals.props" :data="visuals" @on-action="handleActions"/>
   </div>
</template>

<script>
import visuals from "./visuals.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('visuals')
      Event.$off('select-field-changed')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('visuals',visuals,this.$store)

      Event.$on('select-field-changed',(payload) => {
         this.selectFieldChanged(payload)
      })
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
      Wizard: () => import("clarks/components/wizard"),
   },
   computed: {
      ...mapGetters([
         'VisualsModel',
         'visuals',
         'vue_comp',
         'show_create_modal',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'resetForm',
         'resetFormUpdate',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'addVisuals',
         'deleteVisuals',
         'updateVisuals',
         'wizardNextVisual',
         'selectFieldChanged',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('visuals',visuals,this.$store)
      this.$store.commit('vue_comp',this)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .visuals{
      
   }
</style>